import React from 'react';
import './SaveStatusIndicator.css';

const SaveStatusIndicator = ({ saveStatus }) => {
  const getStatusDisplay = () => {
    switch (saveStatus.status) {
      case 'saving':
        return { 
          text: '', 
          color: 'var(--color2)', 
          icon: '↻',
          className: 'spinning'
        };
      case 'saved':
        return { 
          text: '', 
          color: 'var(--color2)', 
          icon: '✔',
          className: ''
        };
      case 'pending':
        return { 
          text: '', 
          color: 'var(--color2)', 
          icon: '✔',
          className: ''
        };
      case 'error':
        return { 
          text: 'Save failed.', 
          color: '#ff0000', 
          icon: '✗',
          className: ''
        };
      case 'idle':
      default:
        // Show checkmark as default state instead of hiding
        return { 
          text: '', 
          color: 'var(--color2)', 
          icon: '✔',
          className: ''
        };
    }
  };

  const statusDisplay = getStatusDisplay();
  
  // Don't render if no status to show
  if (!statusDisplay) return null;

  const { text, color, icon, className } = statusDisplay;

  return (
    <div className={`save-status-indicator ${className}`} style={{ color }}>
      <span className={`save-icon ${className}`}>{icon}</span>
      {text && <span className="save-text">{text}</span>}
      {saveStatus.status === 'error' && saveStatus.onRetry && (
        <button onClick={saveStatus.onRetry} className="retry-btn">
          Retry
        </button>
      )}
    </div>
  );
};

export default SaveStatusIndicator;
